import { render, staticRenderFns } from "./importProfile.vue?vue&type=template&id=17dda843&scoped=true"
import script from "./importProfile.vue?vue&type=script&lang=js"
export * from "./importProfile.vue?vue&type=script&lang=js"
import style0 from "./importProfile.vue?vue&type=style&index=0&id=17dda843&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dda843",
  null
  
)

export default component.exports